import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  // HOME - Our Partner
  homeOurPartner: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  // Category
  mainCategoryList: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  categoryList: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  allCategoryList: {
    data: [],
    isLoading: false
  },
  // END Category

  // Product
  productList: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true,
    meta: {
      page: 0,
      pageSize: 0,
      pageTotal: 0,
      total: 0
    }
  },
  productListTopSales: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  productListLatest: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  productListPopular: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  productDetail: {},
  // END Product

  // Cart
  addToCartSuccess: false,
  cartItems: {
    isLoading: true,
    data: [],
    invalid: [],
    variations_reselect: []
  },
  orderSummary: [],
  tempStoreCart: {},
  mallStatusCheckOut: "",

  // Shop
  shopDetail: {},

  // Order
  availableShippingMethod: [],
  checkoutSuccess: false,
  checkoutOrder: [],
  orderList: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true,
    meta: {
      page: 0,
      pageSize: 0,
      pageTotal: 0,
      total: 0
    }
  },
  orderDetail: {},
  completedOrder: false,

  // Review
  productReviewTag: [],
  productReviewList: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  productReview: false,
  riderReview: false,

  // Voucher
  voucherList: {
    data: [],
    total: 0,
    offset: 0,
    limit: 10,
    isLoadingVoucher: false,
    hasMore: true
  }
};

export default function mallReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    /* Home - Our Partner */
    case actionTypes.HOME_OUR_PARTNER: {
      return {
        ...state
      };
    }
    case actionTypes.HOME_OUR_PARTNER_SUCCESS: {
      let homeOurPartner = cloneDeep(state.homeOurPartner);
      homeOurPartner.isLoading = false;
      homeOurPartner.data = action.data;

      return {
        ...state,
        homeOurPartner
      };
    }
    /* Category */
    case actionTypes.MALL_LOAD_MAIN_CATEGORY_LIST: {
      let mainCategoryList = cloneDeep(state.mainCategoryList);
      mainCategoryList.offset = action.data.offset ? action.data.offset : 0;
      mainCategoryList.limit = action.data.limit ? action.data.limit : 10;
      mainCategoryList.hasMore = false;

      if (mainCategoryList.data.length === 0) {
        mainCategoryList.isLoading = true;
      }

      return {
        ...state,
        mainCategoryList
      };
    }
    case actionTypes.MALL_LOAD_MAIN_CATEGORY_LIST_SUCCESS: {
      let mainCategoryList = cloneDeep(state.mainCategoryList);
      mainCategoryList.isLoading = false;
      mainCategoryList.hasMore = true;

      if (mainCategoryList.offset === 0) {
        mainCategoryList.data = action.data;
      } else {
        mainCategoryList.data = [...mainCategoryList.data, ...action.data];
      }

      if (
        mainCategoryList.data.length === 0 ||
        action.data.length < mainCategoryList.limit
      ) {
        mainCategoryList.hasMore = false;
      }

      return {
        ...state,
        mainCategoryList
      };
    }

    case actionTypes.MALL_LOAD_MAIN_CATEGORY_LIST_FAIL: {
      return {
        ...state,
        mainCategoryList: INITIAL_STATE.mainCategoryList
      };
    }

    case actionTypes.MALL_LOAD_CATEGORY_LIST: {
      let categoryList = cloneDeep(state.categoryList);
      categoryList.offset = action.data.offset ? action.data.offset : 0;
      categoryList.limit = action.data.limit ? action.data.limit : 10;
      categoryList.hasMore = false;

      if (categoryList.data.length === 0) {
        categoryList.isLoading = true;
      }

      return {
        ...state,
        categoryList
      };
    }
    case actionTypes.MALL_LOAD_CATEGORY_LIST_SUCCESS: {
      let categoryList = cloneDeep(state.categoryList);
      categoryList.isLoading = false;
      categoryList.hasMore = true;

      if (categoryList.offset === 0) {
        categoryList.data = action.data;
      } else {
        categoryList.data = [...categoryList.data, ...action.data];
      }

      if (
        categoryList.data.length === 0 ||
        action.data.length < categoryList.limit
      ) {
        categoryList.hasMore = false;
      }

      return {
        ...state,
        categoryList
      };
    }

    case actionTypes.MALL_LOAD_CATEGORY_LIST_FAIL: {
      return {
        ...state,
        categoryList: INITIAL_STATE.categoryList
      };
    }

    case actionTypes.MALL_LOAD_ALL_CATEGORIES: {
      let allCategoryList = cloneDeep(state.allCategoryList);
      allCategoryList.isLoading = true;
      return {
        ...state,
        allCategoryList
      };
    }

    case actionTypes.MALL_LOAD_ALL_CATEGORIES_SUCCESS: {
      let allCategoryList = cloneDeep(state.allCategoryList);
      allCategoryList.data = action.data;
      allCategoryList.isLoading = false;
      return {
        ...state,
        allCategoryList
      };
    }

    case actionTypes.MALL_LOAD_ALL_CATEGORIES_FAIL: {
      return {
        ...state,
        allCategoryList: INITIAL_STATE.allCategoryList
      };
    }
    /* END Category */

    /* Product */
    case actionTypes.MALL_LOAD_PRODUCT_LIST: {
      let name = "productList";
      let data = cloneDeep(state.productList);

      // Top Sales
      if (action.listType === "topSales") {
        name = "productListTopSales";
        data = cloneDeep(state[name]);
      }

      // Latest Product
      if (action.listType === "latest") {
        name = "productListLatest";
        data = cloneDeep(state[name]);
      }

      // Popular Product
      if (action.listType === "popular") {
        name = "productListPopular";
        data = cloneDeep(state[name]);
      }

      data.offset = action.data.offset ? action.data.offset : 0;
      data.limit = action.data.limit ? action.data.limit : 10;
      data.isLoading = true;
      data.hasMore = false;

      if (data.offset === 0) {
        data.data = [];
      }

      return {
        ...state,
        [name]: data
      };
    }
    case actionTypes.MALL_LOAD_PRODUCT_LIST_SUCCESS: {
      let name = "productList";
      let data = cloneDeep(state.productList);
      let actionData = action.data;

      // Top Sales
      if (action.listType === "topSales") {
        name = "productListTopSales";
        data = cloneDeep(state[name]);
      }

      // Latest Product
      if (action.listType === "latest") {
        name = "productListLatest";
        data = cloneDeep(state[name]);
      }

      // Popular Product
      if (action.listType === "popular") {
        name = "productListPopular";
        data = cloneDeep(state[name]);
      }

      // data.data = [...data.data, ...action.data];
      data.data = actionData.data;

      data.meta = {
        page: 1 + data.offset / data.limit,
        pageSize: data.limit,
        pageTotal: Math.ceil(actionData.total / data.limit),
        total: actionData.total
      };

      data.isLoading = false;
      data.hasMore = true;

      if (
        data.data.length === 0 ||
        actionData.data.length < data.limit ||
        data.meta.page === data.meta.pageTotal
      ) {
        data.hasMore = false;
      }

      return {
        ...state,
        [name]: data
      };
    }

    case actionTypes.MALL_LOAD_PRODUCT_LIST_FAIL: {
      let name = "productList";

      // Top Sales
      if (action.listType === "topSales") {
        name = "productListTopSales";
      }

      // Latest Product
      if (action.listType === "popular") {
        name = "productListLatest";
      }

      // Popular Product
      if (action.listType === "popular") {
        name = "productListPopular";
      }

      return {
        ...state,
        [name]: INITIAL_STATE[name]
      };
    }

    case actionTypes.MALL_GET_PRODUCT_DETAIL: {
      let productDetail = cloneDeep(state.productDetail);

      // If different product ID
      if (
        JSON.stringify(productDetail) !==
        JSON.stringify(INITIAL_STATE.productDetail)
      ) {
        if (String(productDetail.product_id) !== String(action.productID)) {
          productDetail = INITIAL_STATE.productDetail;
        }
      }
      return {
        ...state,
        productDetail
      };
    }

    case actionTypes.MALL_GET_PRODUCT_DETAIL_SUCCESS: {
      return {
        ...state,
        productDetail: action.data
      };
    }
    case actionTypes.MALL_GET_PRODUCT_DETAIL_FAIL: {
      return {
        ...state,
        productDetail: INITIAL_STATE.productDetail
      };
    }
    /* END Product */

    /* Cart */
    // Load
    case actionTypes.MALL_LOAD_CART: {
      let cartItems = cloneDeep(state.cartItems);
      cartItems.isLoading = true;

      return {
        ...state,
        cartItems
      };
    }
    case actionTypes.MALL_LOAD_CART_SUCCESS: {
      let cartItems = cloneDeep(state.cartItems);
      cartItems = { ...cartItems, ...action.data };
      cartItems.isLoading = false;

      return {
        ...state,
        cartItems
      };
    }
    case actionTypes.MALL_LOAD_CART_FAIL: {
      return {
        ...state,
        cartItems: INITIAL_STATE.cartItems
      };
    }

    // Insert
    case actionTypes.MALL_INSERT_TO_CART:
    case actionTypes.MALL_INSERT_TO_CART_FAIL: {
      return {
        ...state,
        addToCartSuccess: INITIAL_STATE.addToCartSuccess
      };
    }
    case actionTypes.MALL_INSERT_TO_CART_SUCCESS: {
      return {
        ...state,
        addToCartSuccess: true
      };
    }

    // Order Summary
    case actionTypes.MALL_LOAD_ORDER_SUMMARY:
    case actionTypes.MALL_LOAD_ORDER_SUMMARY_FAIL: {
      return {
        ...state,
        orderSummary: INITIAL_STATE.orderSummary
      };
    }
    case actionTypes.MALL_LOAD_ORDER_SUMMARY_SUCCESS: {
      return {
        ...state,
        orderSummary: action.data
      };
    }
    case actionTypes.MALL_TEMP_STORE_DATA: {
      return {
        ...state,
        tempStoreCart: action.data
      };
    }
    case actionTypes.MALL_CLEAR_DATA_STORE: {
      return {
        ...state,
        tempStoreCart: {}
      };
    }
    case actionTypes.MALL_CHECKOUT_ORDER: {
      return {
        ...state,
        mallStatusCheckOut: "",
        checkoutOrder: ""
      };
    }
    case actionTypes.MALL_CHECKOUT_ORDER_FAIL: {
      return {
        ...state,
        mallStatusCheckOut: action.data
      };
    }
    case actionTypes.MALL_CHECKOUT_ORDER_SUCCESS: {
      return {
        ...state,
        mallStatusCheckOut: "success",
        // checkoutOrder: action.data
        checkoutOrder: "success"
      };
    }
    /* END Cart */

    /* Shop */
    case actionTypes.MALL_LOAD_SHOP_DETAIL:
    case actionTypes.MALL_LOAD_SHOP_DETAIL_FAIL: {
      return {
        ...state,
        shopDetail: INITIAL_STATE.shopDetail
      };
    }
    case actionTypes.MALL_LOAD_SHOP_DETAIL_SUCCESS: {
      return {
        ...state,
        shopDetail: action.data
      };
    }
    /* END Shop */

    /* Order */
    case actionTypes.MALL_CHECK_AVAILABLE_SHIPPING_METHOD:
    case actionTypes.MALL_CHECK_AVAILABLE_SHIPPING_METHOD_FAIL: {
      return {
        ...state,
        availableShippingMethod: INITIAL_STATE.availableShippingMethod
      };
    }
    case actionTypes.MALL_CHECK_AVAILABLE_SHIPPING_METHOD_SUCCESS: {
      return {
        ...state,
        availableShippingMethod: action.data
      };
    }

    // Order List
    case actionTypes.MALL_LOAD_ORDER_LIST: {
      let orderList = cloneDeep(state.orderList);
      orderList.offset = action.data.offset;
      orderList.limit = action.data.limit;
      orderList.isLoading = true;
      orderList.hasMore = false;

      // offset 0 then clear data
      if (orderList.offset === 0) {
        orderList.data = [];
        orderList.totalRecord = 0;
      }

      return {
        ...state,
        orderList
      };
    }
    case actionTypes.MALL_LOAD_ORDER_LIST_SUCCESS: {
      let orderList = cloneDeep(state.orderList);
      let data = action.data;
      orderList.data = data.data;
      orderList.isLoading = false;
      orderList.hasMore = true;

      if (orderList.data.length === 0 || data.data.length < orderList.limit) {
        orderList.hasMore = false;
      }

      orderList.meta = {
        page: 1 + orderList.offset / orderList.limit,
        pageSize: orderList.limit,
        pageTotal: Math.ceil(data.totalRecords / orderList.limit),
        total: data.totalRecords
      };

      return {
        ...state,
        orderList
      };
    }

    case actionTypes.MALL_LOAD_ORDER_LIST_FAIL: {
      return {
        ...state,
        orderList: INITIAL_STATE.orderList
      };
    }

    case actionTypes.MALL_COMPLETE_ORDER: {
      return {
        ...state,
        completedOrder: false
      };
    }
    case actionTypes.MALL_COMPLETE_ORDER_SUCCESS: {
      return {
        ...state,
        completedOrder: true
      };
    }
    // END Order List

    // Order Detail
    case actionTypes.MALL_LOAD_ORDER_DETAIL:
    case actionTypes.MALL_LOAD_ORDER_DETAIL_FAIL: {
      return {
        ...state,
        orderDetail: INITIAL_STATE.orderDetail
        // orderDetail: {}
      };
    }
    case actionTypes.MALL_LOAD_ORDER_DETAIL_SUCCESS: {
      return {
        ...state,
        orderDetail: action.data
      };
    }
    // END Order Detail
    /* END Order */

    /* Review */
    // Review Tag
    case actionTypes.MALL_LOAD_PRODUCT_REVIEW_TAG:
    case actionTypes.MALL_LOAD_PRODUCT_REVIEW_TAG_FAIL: {
      return {
        ...state,
        productReviewTag: INITIAL_STATE.productReviewTag
      };
    }
    case actionTypes.MALL_LOAD_PRODUCT_REVIEW_TAG_SUCCESS: {
      return {
        ...state,
        productReviewTag: action.data
      };
    }
    // END Review Tag

    // Review List
    case actionTypes.MALL_LOAD_PRODUCT_REVIEW_LIST: {
      let productReviewList = cloneDeep(state.productReviewList);
      productReviewList.offset = action.data.offset;
      productReviewList.limit = action.data.limit;
      productReviewList.isLoading = true;
      productReviewList.hasMore = false;

      // offset 0 then clear data
      if (productReviewList.offset === 0) {
        productReviewList.data = [];
      }

      return {
        ...state,
        productReviewList
      };
    }
    case actionTypes.MALL_LOAD_PRODUCT_REVIEW_LIST_SUCCESS: {
      let productReviewList = cloneDeep(state.productReviewList);
      productReviewList.data = [...productReviewList.data, ...action.data];
      productReviewList.isLoading = false;
      productReviewList.hasMore = true;

      if (
        productReviewList.data.length === 0 ||
        action.data.length < productReviewList.limit
      ) {
        productReviewList.hasMore = false;
      }

      return {
        ...state,
        productReviewList
      };
    }

    case actionTypes.MALL_LOAD_PRODUCT_REVIEW_LIST_FAIL: {
      return {
        ...state,
        productReviewList: INITIAL_STATE.productReviewList
      };
    }
    // END Review List
    // Post Product Review
    case actionTypes.MALL_PRODUCT_REVIEW: {
      return {
        ...state,
        productReview: false
      };
    }
    case actionTypes.MALL_PRODUCT_REVIEW_SUCCESS: {
      return {
        ...state,
        productReview: true
      };
    }
    // END Post Product Review
    // Post Rider Review
    case actionTypes.MALL_PRODUCT_RIDER_REVIEW: {
      return {
        ...state,
        riderReview: false
      };
    }
    case actionTypes.MALL_PRODUCT_RIDER_REVIEW_SUCCESS: {
      return {
        ...state,
        riderReview: true
      };
    }
    // END Post Rider Review
    /* END Review */

    // Voucher
    case actionTypes.MALL_LOAD_VOUCHER_LIST: {
      let voucherList = { ...state.voucherList };
      voucherList.offset = action.data.offset;
      voucherList.limit = action.data.limit;
      voucherList.isLoadingVoucher = true;

      if (action.data.offset === 0) {
        voucherList.data = [];
      }

      return {
        ...state,
        voucherList
      };
    }
    case actionTypes.MALL_LOAD_VOUCHER_LIST_SUCCESS: {
      let voucherList = { ...state.voucherList };

      voucherList.data = [...voucherList.data, ...action.data.data];
      voucherList.isLoadingVoucher = false;
      voucherList.hasMore = true;
      voucherList.total = action.data.total;
      if (
        parseInt(voucherList.offset) >= voucherList.total ||
        voucherList.data.length === 0 ||
        voucherList.data.length < voucherList.limit
      ) {
        voucherList.hasMore = false;
      }
      return {
        ...state,
        voucherList
      };
    }
    // END Voucher

    default:
      return state;
  }
}
